import { render, staticRenderFns } from "./alipayWithdrawDetail.vue?vue&type=template&id=a53f3476&scoped=true&"
import script from "./alipayWithdrawDetail.vue?vue&type=script&lang=js&"
export * from "./alipayWithdrawDetail.vue?vue&type=script&lang=js&"
import style0 from "./alipayWithdrawDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./alipayWithdrawDetail.vue?vue&type=style&index=1&id=a53f3476&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53f3476",
  null
  
)

export default component.exports